import { render, staticRenderFns } from "./AttributeValueReader.vue?vue&type=template&id=c2ff2fca&"
import script from "./AttributeValueReader.vue?vue&type=script&lang=js&"
export * from "./AttributeValueReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports